import { render, staticRenderFns } from "./ResearchBenefitsForm.vue?vue&type=template&id=1467c67c&"
import script from "./ResearchBenefitsForm.vue?vue&type=script&lang=js&"
export * from "./ResearchBenefitsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports